import startsWith from 'ramda/es/startsWith';
import tail from 'ramda/es/tail';

export const stringIsPartial = (stateString: string): boolean => startsWith('.', stateString);

export const stringIsNegative = (stateString: string): boolean => startsWith('!', stateString);

export const trimNegativeFromString = (stateString: string): string => (stringIsNegative(stateString) ? tail(stateString) : stateString);
